import React from "react";

import { ODC_FIXED_COLUMNS, ODC_FIXED_TOTAL_WIDTH } from "./weeklyEACODCColumns";

export default function WeeklyEACODCFixedTable({ odcDetails }) {
  return (
    <table
      className="firstTableFin weeklyEac"
      cellPadding={0}
      cellSpacing={0}
      style={{ width: ODC_FIXED_TOTAL_WIDTH, tableLayout: "fixed" }}
    >
      <thead>
        <tr>
          {ODC_FIXED_COLUMNS.map((column) => (
            <th
              key={column.label}
              style={{ width: column.width, minWidth: column.width }}
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {odcDetails.map((odc) => (
          <tr key={odc.odcId}>
            {ODC_FIXED_COLUMNS.map((column) => (
              <td
                key={column.label}
                style={{ minWidth: column.width, maxWidth: column.width }}
                title={column.accessor(odc) ?? ""}
              >
                {column.accessor(odc) ?? ""}
              </td>
            ))}
          </tr>
        ))}
        <tr className="totalRow">
          <td colSpan={ODC_FIXED_COLUMNS.length}>Total Other Direct Costs</td>
        </tr>
      </tbody>
    </table>
  );
}
